import { StyleSheet, View } from '../../compiler'
import { colors, typoStyles } from '../../constants'
import BoltIcon from '../heroicons/micro/BoltIcon'
import ChatBubbleLeftRightIcon from '../heroicons/micro/ChatBubbleLeftRightIcon'
import CheckIcon from '../heroicons/micro/CheckIcon'
import ExclamationCircleIcon from '../heroicons/micro/ExclamationCircleIcon'
import LightBulbIcon from '../heroicons/solid/LightBulbIcon'
import MarkdownText from '../MarkdownText'
import RowListItem from '../RowListItem'

const styles = StyleSheet.create({
  column: {
    // flex: 1, // equal width for all columns
    borderWidth: 1,
    borderColor: colors.lightGrey,
    borderRadius: 8,
    backgroundColor: colors.lightPaleGrey
  },
  columnTopContainer: {
    backgroundColor: colors.paleGray,
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 24,
    paddingVertical: 16
  },
  divider: { width: '100%', height: 1, backgroundColor: colors.lightGrey },
  header: { ...typoStyles.T2MediumBlue, textTransform: 'uppercase' }
})

const Divider = () => <View style={styles.divider}></View>

const Insights = ({ insights, labels }) => {
  const {
    insights_title,
    chances_label,
    risks_label,
    interviews_label,
    measures_label
  } = labels

  const { chances, risks, interviews, measures } = insights

  return (
    <View style={styles.column}>
      <View style={styles.columnTopContainer}>
        <View
          style={{
            width: 40,
            height: 40,
            borderRadius: 6,
            backgroundColor: colors.paleWhiteBlue
          }}
          className='flex items-center justify-center'
        >
          <LightBulbIcon
            style={{ width: 20, height: 20 }}
            color={colors.darkBlue}
          />
        </View>
        <MarkdownText style={[typoStyles.H4Black, { marginLeft: 24 }]}>
          {insights_title}
        </MarkdownText>
      </View>
      <View>
        {!!chances.length && (
          <View>
            <View style={{ padding: 24 }}>
              <MarkdownText style={styles.header}>{chances_label}</MarkdownText>
              <View
                style={{ marginTop: 16, flexDirection: 'column', rowGap: 16 }}
              >
                {chances.map((paragraph, index) => (
                  <RowListItem key={index} Icon={CheckIcon} text={paragraph} />
                ))}
              </View>
            </View>
            <Divider />
          </View>
        )}

        {!!risks.length && (
          <View>
            <View style={{ padding: 24 }}>
              <MarkdownText style={styles.header}>{risks_label}</MarkdownText>
              <View
                style={{ marginTop: 16, flexDirection: 'column', rowGap: 16 }}
              >
                {risks.map((paragraph, index) => (
                  <RowListItem
                    key={index}
                    Icon={ExclamationCircleIcon}
                    text={paragraph}
                  />
                ))}
              </View>
            </View>
            <Divider />
          </View>
        )}

        {!!interviews.length && (
          <View>
            <View style={{ padding: 24 }}>
              <MarkdownText style={styles.header}>
                {interviews_label}
              </MarkdownText>
              <View
                style={{ marginTop: 16, flexDirection: 'column', rowGap: 16 }}
              >
                {interviews.map((paragraph, index) => (
                  <RowListItem
                    key={index}
                    Icon={ChatBubbleLeftRightIcon}
                    text={paragraph}
                  />
                ))}
              </View>
            </View>
            <Divider />
          </View>
        )}

        {!!measures.length && (
          <View>
            <View style={{ padding: 24 }}>
              <MarkdownText style={styles.header}>
                {measures_label}
              </MarkdownText>
              <View
                style={{ marginTop: 16, flexDirection: 'column', rowGap: 16 }}
              >
                {measures.map((paragraph, index) => (
                  <RowListItem key={index} Icon={BoltIcon} text={paragraph} />
                ))}
              </View>
            </View>
          </View>
        )}
      </View>
    </View>
  )
}

export default Insights
